module.exports = ".width50{width:50%;padding:5px}.mb-16{margin-bottom:16px;margin-left:-95px}\n"